<template>
  <v-container  class="resident-account" fluid>
    <v-row align="center">
      <v-col cols="auto pr-12 ml-6">
        <h1>Список клиентов</h1>
      </v-col>
      <v-switch
        v-if="this.roleName === 'admin'"
        class="pl-10"
        v-model="withoutSubscribers"
        @click="showDuplicate()"
        flat
        inset
        label="Показать клиентов только с абонентами"
      >
      </v-switch>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="mr-7">
        <v-menu
          bottom
          left
          offset-y
          origin="right right"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$checkPermission('export_csv_client')"
              color="primary"
              outlined
              class="text-none mr-2"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Скачать отчёт
            </v-btn>
          </template>
          <v-list width="auto" dense>
            <v-list-item class="list-item-mobile-version">
              <v-btn
                @click.prevent="downloadReport()"
                color="primary"
                outlined
                class="text-none mr-2"
                dark
                rounded
              >
                Полный отчёт
              </v-btn>
              <v-btn
                @click.prevent="downloadReportPage()"
                color="primary"
                outlined
                class="text-none mr-2"
                dark
                rounded
              >
                Отчёт на странице
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="$checkPermission('create_client')"
          color="primary"
          class="text-none"
          dark
          to="/client/new"
        >
          Новый Клиент
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-row no-gutters class="mb-5 pt-4">
            <v-text-field
              label="Номер телефона"
              outlined
              dense
              hide-details
              class="input input-search mr-2 mb-2 pl-2"
              height="100%"
              prepend-inner-icon="mdi-phone"
              v-model="serchPhone"
              @keyup="(e) => e.keyCode === 13 && filterClients()"
              length="20"
            />
            <v-text-field
              label="Адрес"
              outlined
              dense
              hide-details
              class="input input-search mr-2 mb-2 pl-2"
              height="100%"
              prepend-inner-icon="mdi-rename-box-outline"
              v-model="serchAddress"
              @keyup="(e) => e.keyCode === 13 && filterClients()"
              length="20"
            />
            <v-text-field
              label="Код ключа"
              outlined
              dense
              hide-details
              class="input input-search mr-2 mb-2 pl-2"
              height="100%"
              prepend-inner-icon="mdi-key-outline"
              v-model="serchCode"
              @keyup="(e) => e.keyCode === 13 && filterClients()"
              length="20"
            />
            <v-btn
              dark
              class="btn blue darken-3 white px-7 text-none ml-2"
              @click.prevent="filterClients"
            >
              Поиск
            </v-btn>
          </v-row>
          <v-card flat>
            <v-data-table
              class="table"
              :options.sync="options"
              :headers="headers"
              :items="clients"
              disable-sort
              :server-items-length="totalClients"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [5, 10, 20, 50, 100, 500],
              }"
            >
              <template v-slot:item.telephone="{ item }">
                {{ formatPhoneNumber(item.telephone) }}
              </template>
              <template v-slot:item.doorphones="{ item }">
                  <ul v-for="doorphone in getDoorphones(item)" v-bind:key="doorphone.id">
                    <router-link class="routerLink" :to="`/doorphones/${doorphone.id}`">
                      {{ getDoorphoneAddress(doorphone) }}
                    </router-link>
                  </ul>
              </template>
              <template v-slot:item.barriers="{ item }">
                <ul v-for="barrier in getBarriers(item)" v-bind:key="barrier.id">
                  <router-link class="routerLink" :to="`/barrier/${barrier.id}`">
                    {{ barrier.address }}
                  </router-link>
                </ul>
              </template>
              <template v-slot:item.StatusClient="{ item }">
                <ul v-for="apartment_sip_settings in getStatusClient(item)" v-bind:key="apartment_sip_settings.id">
                  {{ getStatusPaid(apartment_sip_settings.paid) }}
                </ul>
              </template>
              <template v-slot:item.status="{ item }">
                <ul v-for="status in getStatuses(item)" v-bind:key="status.id">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        tile
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="btn__icon pa-0"
                        width="18"
                        height="18"
                        style="cursor: default;"
                      >
                        <v-icon
                          :color="(status === 'A') ? 'green' : (status === 'B') ? 'yellow' : 'red'"
                          x-small
                        >
                          mdi-checkbox-blank-circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ getStatusesClients(status) }}</span>
                  </v-tooltip>
                </ul>
              </template>
              <template v-slot:item.Code="{ item }">
                  <ul v-for="keys in getKeys(item)" v-bind:key="keys.id">
                    {{ keys.code }}
                  </ul>
              </template>
              <template v-slot:item.actions="{ item }">
                <template v-if="$canRoute('DetailClientGeneralInfoClient')">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        tile
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="btn__icon pa-0"
                        width="18"
                        height="18"
                        :to="`/client/${item.id}`"
                      >
                        <v-icon>mdi-information-slab-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Информация</span>
                  </v-tooltip>
                </template>
                <template v-else>Информация</template>
              </template>
            </v-data-table>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import cp1251Encode from '@/mixins/cp1251Encode';

export default {
  name: 'Clients',
  mixins: [ruDateFormatMixin, cp1251Encode],
  data () {
    return {
      dialog: {},
      isCreated: false,
      options: {
        page: 1,
        itemsPerPage: 20,
      },
      filters: {},
      serchPhone: '',
      serchAddress: '',
      serchCode: '',
      withoutSubscribers: false,
      include: ['abonents.doorphones', 'abonents.keys', 'abonents.apartmentSipSettings'],
      totalClients: 0,
      headers: [
        { text: 'Телефон', value: 'telephone', sortable: false },
        { text: 'Домофон', value: 'doorphones' },
        { text: 'Шлагбаум', value: 'barriers' },
        { text: 'Код ключа', value: 'Code', sortable: false },
        { text: 'Статус аккаунта', value: 'StatusClient', sortable: false },
        { text: 'Статус', value: 'status' },
        { text: '', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      clients: 'Client/clients',
      roleName: 'roleName',
    }),
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.getClients();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      loadClients: 'Client/loadClients',
      deleteClient: 'Client/deleteClient',
      exportCsv: 'Client/exportCsv',
    }),
    formatPhoneNumber (phoneNumber) {
      phoneNumber = phoneNumber.toString();
      const digits = phoneNumber.replace(/\D/g, '');
      return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    },
    filterClients () {
      this.options.page = 1;
      // const phoneNumberToSend = this.serchPhone.replace(/\D/g, '');
      this.filters = {
        ...(this.serchPhone && { telephone_v2: this.serchPhone }),
        ...(this.serchAddress && { address: this.serchAddress }),
        ...(this.serchCode && { code: this.serchCode }),
      };
      if (this.withoutSubscribers) {
        this.filters.has_abonents = 'true';
      } else {
        delete this.filters.has_abonents;
      }
      this.getClients();
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.type === 'G') {
        address += ' (калитка)';
      }
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}, кв.${doorphone.apartment}`;
        if (doorphone.type === 'A') {
          address += ' (доп.вход)';
        }
      }
      return address;
    },
    getClients () {
      this.loadClients({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: this.filters,
        include: this.include,
        sort: this.sort = ['-id'],
      })
        .then(({ meta }) => {
          this.totalClients = meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке клиентов');
        });
    },
    downloadReport () {
      this.exportCsv()
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response], {
            type: 'application/csv',
          }));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'ListClient.csv';
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.$flash_warning('Ошибка при скачивании отчёта');
        });
    },
    downloadReportPage () {
      const lines = [];
      this.clients.forEach((item) => {
        const createdAt = this.ruDateFormat(item.created_at, true);

        if (item.abonents && item.abonents.length > 0) {
          item.abonents.forEach((abonent) => {
            const address = abonent.address || '';
            const statusPaid = this.getStatusPaid(abonent?.apartment_sip_settings?.[0]?.paid) || '';
            const statusesClients = this.getStatusesClients(abonent?.status) || '';

            const line = [
              item.telephone, address,
              statusPaid, statusesClients, createdAt,
            ].join(';');
            lines.push(line);
          });
        } else {
          const line = [
            item.telephone, '',
            '', '',
            createdAt,
          ].join(';');
          lines.push(line);
        }
      });

      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'list-clients.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getStatusPaid (paid) {
      switch (paid) {
        case true: return ' Pro - версия';
        case false: return ' Lite - версия';
      }
    },
    getStatusesClients (status) {
      switch (status) {
        case 'A': return ' Активен ';
        case 'B': return ' Заблокирован ';
        case 'D': return ' Удален ';
      }
    },
    getDoorphones (item) {
      const doorphones = [];
      item.abonents.forEach(abonent => {
        if (abonent.doorphones) {
          abonent.doorphones.forEach(doorphone => {
            doorphone.apartment = abonent.apartment;
            doorphones.push(doorphone);
          });
        }
      });
      return doorphones;
    },
    getBarriers (item) {
      const barriersSet = new Set();

      item.abonents.forEach(abonent => {
        if (abonent.doorphones) {
          abonent.doorphones.forEach(doorphone => {
            if (doorphone.barriers) {
              doorphone.barriers.forEach(barrier => {
                barriersSet.add(barrier);
              });
            }
          });
        }
      });

      return Array.from(barriersSet);
    },
    showDuplicate () {
      this.options.page = 1;
      this.filterClients();
    },
    getKeys (item) {
      const keys = [];
      item.abonents.forEach(abonent => {
        if (abonent.keys) {
          abonent.keys.forEach(doorphone => {
            keys.push(doorphone);
          });
        }
      });
      return keys;
    },
    getStatusClient (item) {
      const apartmentSipSettings = [];
      item.abonents.forEach(abonent => {
        if (abonent.apartment_sip_settings) {
          abonent.apartment_sip_settings.forEach(doorphone => {
            apartmentSipSettings.push(doorphone);
          });
        }
      });
      return apartmentSipSettings;
    },
    getStatuses (item) {
      const status = [];
      item.abonents.forEach(abonent => {
        status.push(abonent.status);
      });
      return status;
    },
  },
  created () {
    this.isCreated = true;
    this.getClients();
  },
};
</script>

<style lang="scss" scoped>

.input {
  &-search {
    max-width: 301px;
    width: 100%;
  }
}
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

.v-icon-before {
  margin-right: 8px;
}

.custom-input {
  width: 260px;
  border: none;
  outline: none;
}
</style>
